var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIdentifying(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "service_identifying_",
    "data-name": "service_identifying ",
    transform: "translate(0 -1041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5883",
    "data-name": "Rectangle 5883",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(0 1041)",
    fill: "#fe0",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-bulb",
    "data-name": "001-bulb",
    transform: "translate(19 1055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M46.449,88a10.065,10.065,0,0,0-7.069,2.854,1.475,1.475,0,0,0,0,2.121,1.567,1.567,0,0,0,2.175,0A6.966,6.966,0,0,1,46.449,91a6.844,6.844,0,0,1,6.92,6.75,6.711,6.711,0,0,1-3.775,6.014c-.027.014-.048.032-.075.047a1.589,1.589,0,0,0-.135.085c-.041.029-.078.06-.115.092s-.071.064-.1.1-.066.075-.1.115-.057.077-.082.117-.048.083-.07.125-.042.089-.061.137a1.388,1.388,0,0,0-.043.136c-.012.047-.024.093-.032.141a1.313,1.313,0,0,0-.016.158c0,.029-.008.056-.008.084v1.65H44.142V105.1c0-.028-.007-.055-.008-.083,0-.053-.008-.106-.016-.158a1.376,1.376,0,0,0-.032-.141c-.012-.046-.026-.092-.043-.136a1.475,1.475,0,0,0-.061-.137c-.021-.042-.044-.084-.07-.125s-.053-.079-.082-.117-.062-.078-.1-.115a1.683,1.683,0,0,0-.22-.192c-.043-.031-.089-.058-.134-.085-.026-.015-.048-.034-.075-.047a6.714,6.714,0,0,1-3.775-6.015,1.538,1.538,0,0,0-3.076,0,9.65,9.65,0,0,0,4.614,8.211V110.5a5.384,5.384,0,0,0,10.765,0v-4.539a9.651,9.651,0,0,0,4.614-8.211,9.887,9.887,0,0,0-10-9.75Zm0,24.75a2.282,2.282,0,0,1-2.307-2.25v-.75h4.614v.75A2.282,2.282,0,0,1,46.449,112.75Zm0,0",
    transform: "translate(-32.949 -79.75)",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M127.529,3V1.5a1.538,1.538,0,0,0-3.076,0V3a1.538,1.538,0,0,0,3.076,0Zm0,0",
    transform: "translate(-112.491)",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M3.712,53.046,2.625,51.985a1.565,1.565,0,0,0-2.174,0,1.473,1.473,0,0,0,0,2.121l1.087,1.061a1.565,1.565,0,0,0,2.175,0A1.472,1.472,0,0,0,3.712,53.046Zm0,0",
    transform: "translate(0 -46.713)",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M239.139,51.985l-1.087,1.061a1.474,1.474,0,0,0,0,2.121,1.565,1.565,0,0,0,2.175,0l1.087-1.061a1.474,1.474,0,0,0,0-2.121A1.566,1.566,0,0,0,239.139,51.985Zm0,0",
    transform: "translate(-214.763 -46.713)",
    fill: "#fe0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIdentifying);
export default __webpack_public_path__ + "static/media/service_identifying.6abdb567651b0433a938885e53c82449.svg";
export { ForwardRef as ReactComponent };